import keyvisual from './ticket/top/keyvisual'
import conversion from './ticket/top/conversion'

import sticky from './ticket/howto/sticky'
import modalSeat from './ticket/howto/modal-seat'

import stickyStudiumAccordion from './ticket/ticket/sticky-studium-accordion'
import transfer from './ticket/ticket/ticket-transfer'

(() => {
  // /ticket/ で動作
  keyvisual();
  conversion();

  // /ticket/howto/ で動作
  sticky();
  modalSeat();

  // 5-3 ~ 以降のページ
  // or
  // ticket.pist6.com で動作
  transfer();
  stickyStudiumAccordion();
})()
